import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { PatientFormData } from 'models/order-input/shared';

type PatientSummaryProps = {
    patient?: PatientFormData;
};
const PatientSummary: FC<PatientSummaryProps> = ({ patient }) => {
    const { t: translate } = useTranslation(['common', 'orders']);

    return (
        <Fragment>
            {patient ? (
                <Fragment>
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:NAME')}:</Typography>
                        </Box>
                        <Box>{`${patient.firstName} ${patient.lastName}`}</Box>
                    </Box>
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:PERSONAL_NUMBER')}:</Typography>
                        </Box>
                        <Box>{patient.personalIdentityNumber || translate('orders:MISSING_PERSONAL_NUMBER')}</Box>
                    </Box>
                </Fragment>
            ) : undefined}
        </Fragment>
    );
};

export default PatientSummary;
